import { createLucideIcon } from 'lucide-react'

export const IncludeCellIcon = createLucideIcon('include-cell', [
	[
		'path',
		{
			d: 'M 1.7 12.1 C1.7 12.2 5.6 19.1 7.1 21.7',
			key: '15dy1u',
		},
	],
	[
		'path',
		{
			d: 'M 12 17 L 12 6.5',
			key: 'e5xmz4',
		},
	],
	[
		'path',
		{
			d: 'M 17 2.5 L 7.1 2.5',
			key: '1dnyza',
		},
	],
	[
		'path',
		{
			d: 'M 17 21.7 L 22.3 12',
			key: '5jfaih',
		},
	],
	[
		'path',
		{
			d: 'M 22.3 12 L 17 2.5',
			key: 'fu75vu',
		},
	],
	[
		'path',
		{
			d: 'M 6.5 12 L 17 12',
			key: '1k2apm',
		},
	],
	[
		'path',
		{
			d: 'M 7.1 2.5 L 1.7 12.1',
			key: '175clm',
		},
	],
	[
		'path',
		{
			d: 'M 7.1 21.7 L 17 21.7',
			key: '77mt11',
		},
	],
])
